import React from "react";
import {useAuth} from "../auth/use-auth";
import {Navigate, Route, Routes} from "react-router-dom";
import Signin from "../pages/Signin";
import SignedinInterface from "./SignedinInterface";
import MyLoader from "./MyLoader/MyLoader";

const AppRouter = () => {
    const auth = useAuth();

    if (auth.isLoading) return <MyLoader/>;
    return (
        <div className="container">
            {auth.user ? (
                <SignedinInterface/>
            ) : (
                <Routes>
                    <Route exact path="/signin" element={<Signin/>}/>
                    <Route exact path="*" element={<Navigate to="/signin"/>}/>
                </Routes>
            )}
        </div>
    );
};

export default AppRouter;
